import API, { graphqlOperation } from '@aws-amplify/api'

import findIndex from 'lodash/findIndex'

import sensorQuery from './sensor-query.graphql'
import sensorValuesQuery from './sensor-values-query.graphql'
import sensorEnvMutation from './sensor-env-update.graphql'

const state = {
  sensors: []
}

const getters = {
  getSensorById: (state) => (id) => {
    return state.sensors.find(sensor => sensor.device === id)
  }
}

const mutations = {
  __reset (state) {
    state.sensors = []
  },
  setSensors (state, sensors) {
    state.sensors = sensors
  },
  updateSensorValues (state, sensors) {
    sensors.forEach(function (sensor) {
      const i = findIndex(state.sensors, {device: sensor.device})
      Object.assign(state.sensors[i], sensor)
    })
  },
  updateEnv (state, data) {
    const i = findIndex(state.sensors, {device: data.device})
    state.sensors[i].environment = data.env
  }
}

function prepareValues (sensors) {
  // Sanitize null sensor values
  return sensors.map(s => {
    if (s.values) {
      Object.keys(s.values).forEach(key => {
        let v = s.values[key]
        if (v == null) {
          s.values[key] = {
            'ts': 0,
            'val': '?'
          }
        }
      })
    }
    return s
  })
}

function setLatestTimestamp (sensors) {
  return sensors.map(s => {
    s.ts = 0
    s.hasConnection = false
    if (s.values) {
      s.ts = Object.values(s.values).map(v => v.ts).sort().reverse()[0]
      s.hasConnection = s.ts >= Date.now() - 1000 * 60 * 5
    }
    return s
  })
}

function prepareAlarms (sensors) {
  sensors = sensors.map(s => {
    s.alarmSeries = {
      '12': [],
      '24': [],
    }
    if (s.alarms) {
      s.alarmSeries = {
        '12': s.alarms.filter(a => a.ts > new Date().getTime() - 12 * 60 * 60 * 1000).map(a => ({
          x: new Date(a.ts),
          y: 0,
          r: 10
        })),
        '24': s.alarms.filter(a => a.ts > new Date().getTime() - 24 * 60 * 60 * 1000).map(a => ({
          x: new Date(a.ts),
          y: 0,
          r: 10
        }))
      }
    }
    return s
  })
  return sensors
}

const actions = {
  async getSensors ({commit}) {
    const sv = await API.graphql(graphqlOperation(sensorQuery))
    let sensors = prepareValues(sv.data.readSensors)
    sensors = setLatestTimestamp(sensors)
    sensors = prepareAlarms(sensors)
    commit('setSensors', sensors)
  },
  async getSensorValues ({commit}) {
    const sv = await API.graphql(graphqlOperation(sensorValuesQuery))
    let sensors = prepareValues(sv.data.readSensors)
    sensors = setLatestTimestamp(sensors)
    sensors = prepareAlarms(sensors)
    commit('updateSensorValues', sensors)
  },
  async updateEnv ({commit}, data) {
    const env = await API.graphql(graphqlOperation(sensorEnvMutation, data))
    commit('updateEnv', {device: data.device, env: env.data.updateEnvironment})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
